import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.scss';

import React, {
  useCallback, useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import DatePicker from 'react-datepicker';
import { parseISO, formatISO } from 'date-fns';
import Error from '@components/form/error';

export default function TMDatePicker({
  label,
  minDate,
  maxDate,
  isStartDate,
  isEndDate,
  onlyDate,
  ...props
}) {
  const [field, meta, helpers] = useField(props);
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    try {
      setStartDate(field.value ? parseISO(field.value) : null);
    } catch (e) { /* empty */ }
  }, [field.value]);

  const handleChangeValue = useCallback((date) => {
    if (date instanceof Date && Number.isNaN(date.getTime())) return;
    if (isStartDate) {
      date.setHours(0, 0, 0, 0);
    } else if (isEndDate) {
      date.setHours(23, 59, 59, 59);
    }

    setStartDate(date);
    if (onlyDate) {
      helpers.setValue(formatISO(date, { representation: 'date' }));
    } else {
      helpers.setValue(formatISO(date));
    }
  }, [isStartDate, isEndDate, onlyDate]);

  return (
    <div className={`input__wrapper ${ meta.touched && !!meta.error ? 'error' : '' }`}>
      <label>
        <span className='input__wrapper__label'>{label}</span>
        <div className='input__wrapper__input'>
          <DatePicker
            dateFormat='dd/MM/yyyy'
            selected={startDate}
            onChange={handleChangeValue}
            minDate={minDate}
            maxDate={maxDate}
            {...props}
            autoComplete='off'
            onKeyDown={(e) => {
              e.preventDefault();
            }}
          />
        </div>
      </label>
      <Error name={field.name} />
    </div>
  );
}

TMDatePicker.defaultProps = {
  label: '',
  minDate: '',
  maxDate: '',
  onlyDate: false,
  isStartDate: false,
  isEndDate: false,
};

TMDatePicker.propTypes = {
  isEndDate: PropTypes.bool,
  isStartDate: PropTypes.bool,
  label: PropTypes.string,
  onlyDate: PropTypes.bool,
  maxDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  minDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
};
